<template>
  <div
    data-test="graphics-multiSettings"
  >
    <SidebarSettingsGroup
      v-if="hasPositionSettings"
      title="Size & Placement"
      collapsible
      element-type="multi"
      data-test="graphics-multiSettings-sizePlacement"
    >
      <div class="sidebar-form-group">
        <label class="sidebar-form-label">Align</label>
        <button
          v-for="align in alignments"
          :key="align.align"
          :data-balloon="align.align"
          :data-balloon-pos="align.balloonPosition"
          class="btn btn-style-d btn-layer-position"
          :data-test="`graphics-multiSettings-align-${align.align}`"
          :data-entity="`graphics-multiSettings-align-${align.align}`"
          @click="placement(align.align)"
        >
          <span :class="getAlignIconClass(align.align)"></span>
        </button>
      </div>

      <div class="sidebar-form-group">
        <label class="sidebar-form-label">Distribute</label>
        <button
          v-for="distribute in distributes"
          :key="distribute.distribute"
          :disabled="isDistributeDisabled"
          :data-balloon="distribute.distribute"
          :data-balloon-pos="distribute.balloonPosition"
          class="btn btn-style-d btn-layer-position"
          :data-test="`graphics-multiSettings-distribute-${distribute.distribute}`"
          :data-entity="`graphics-multiSettings-distribute-${distribute.distribute}`"
          @click="distributeElements(distribute.distribute)"
        >
          <span
            :class="{
              'fa-solid fa-distribute-spacing-horizontal': distribute.distribute === 'horizontal',
              'fa-solid fa-distribute-spacing-vertical': distribute.distribute === 'vertical',
            }"
          ></span>
        </button>
      </div>

      <div class="sidebar-form-group">
        <label class="sidebar-form-label">Nudge</label>
        <button
          class="btn btn-style-d btn-layer-position"
          data-test="graphics-multiSettings-nudge-up"
          data-entity="graphics-multiSettings-nudge-up"
          @click="nudgeAll('up')"
        >
          <span class="fa-solid fa-arrow-up"></span>
        </button>
        <button
          class="btn btn-style-d btn-layer-position"
          data-test="graphics-multiSettings-nudge-down"
          data-entity="graphics-multiSettings-nudge-down"
          @click="nudgeAll('down')"
        >
          <span class="fa-solid fa-arrow-down"></span>
        </button>
        <button
          class="btn btn-style-d btn-layer-position"
          data-test="graphics-multiSettings-nudge-right"
          data-entity="graphics-multiSettings-nudge-right"
          @click="nudgeAll('right')"
        >
          <span class="fa-solid fa-arrow-right"></span>
        </button>
        <button
          class="btn btn-style-d btn-layer-position"
          data-test="graphics-multiSettings-nudge-left"
          data-entity="graphics-multiSettings-nudge-left"
          @click="nudgeAll('left')"
        >
          <span class="fa-solid fa-arrow-left"></span>
        </button>
      </div>
    </SidebarSettingsGroup>

    <SidebarSettingsGroup
      v-if="hasAnimationSettings"
      title="Animation"
      collapsible
      element-type="multi-animation"
      data-test="graphics-multiSettings-animation"
    >
      <animation-settings :element="element" />
    </SidebarSettingsGroup>
  </div>
</template>

<script>
import settingsMixins from '../../mixins/settings-mixins';
import EventBus from '../../utils/event-bus';

import AnimationSettings from './Animation.vue';

export default {
  name: 'MultiSettings',
  components: {
    AnimationSettings,
  },
  mixins: [settingsMixins],
  props: {
    element: {
      type: Object,
      required: true,
    },
    hasPositionSettings: {
      type: Boolean,
      default: true,
    },
    hasAnimationSettings: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      alignments: [
        { align: 'left', balloonPosition: 'up-left' },
        { align: 'center', balloonPosition: 'up' },
        { align: 'right', balloonPosition: 'up' },
        { align: 'top', balloonPosition: 'up' },
        { align: 'middle', balloonPosition: 'up-right' },
        { align: 'bottom', balloonPosition: 'down-left' },
      ],
      distributes: [
        {
          distribute: 'horizontal',
          balloonPosition: 'up-left',
        },
        {
          distribute: 'vertical',
          balloonPosition: 'up',
        },
      ],
    };
  },
  computed: {
    isDistributeDisabled() {
      return this.selectedElements.length < 3;
    },
  },
  methods: {
    getAlignIconClass(align) {
      const alignIconMap = {
        top: 'fa-solid fa-objects-align-top',
        middle: 'fa-solid fa-objects-align-center-vertical',
        bottom: 'fa-solid fa-objects-align-bottom',
        left: 'fa-solid fa-objects-align-left',
        center: 'fa-solid fa-objects-align-center-horizontal',
        right: 'fa-solid fa-objects-align-right',
      };

      return alignIconMap[align] || 'fa-solid fa-objects-align-center-horizontal';
    },
    placement(align) {
      EventBus.emit('align', align);
    },
    distributeElements(distribute) {
      EventBus.emit('distribute', distribute);
    },
    nudgeAll(direction) {
      this.selectedElements.forEach((element) => {
        switch (direction) {
          case 'left':
            this.decrementPosition('left', 1, element);
            break;
          case 'up':
            this.decrementPosition('top', 1, element);
            break;
          case 'right':
            this.incrementPosition('left', 1, element);
            break;
          case 'down':
            this.incrementPosition('top', 1, element);
            break;
          default:
            break;
        }

        if (this.getElementParentGroupId(element) !== 'root') {
          this.onMoveOrResize({
            value: {
              groupId: this.getElementParentGroupId(element),
            },
          });
        }
      });
    },
  },
};
</script>
